var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIpShirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 21H5a2 2 0 0 1-2-2V4c0-.6.4-1 1-1h12c.6 0 1 .4 1 1v15a2 2 0 1 0 4 0V7c0-.6-.4-1-1-1h-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3v1a3 3 0 1 0 6 0V3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11h.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15h.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIpShirt);
export default __webpack_public_path__ + "static/media/icon-ip-shirt.ee175bc8ebc689fcec3342a31d8a0afb.svg";
export { ForwardRef as ReactComponent };